const CURRENCY_SYMBOL_CHAR = Object.freeze({
    AFN: 'Af',
    ARS: 'AR$',
    AUD: 'AU$',
    AZN: 'man.',
    BAM: 'KM',
    BDT: 'Tk',
    BRL: 'R$',
    BYN: 'Br',
    CAD: 'CA$',
    CHF: '₣',
    CLP: 'CL$',
    CNY: 'CN¥',
    COP: 'CO$',
    CRC: '₡',
    CZK: 'Kč',
    DKK: 'Dkr',
    EUR: '€',
    HKD: 'HK$',
    HRK: 'kn',
    HUF: 'Ft',
    KRW: '₩',
    GBP: '£',
    JPY: '¥',
    USD: '$'
})

export default CURRENCY_SYMBOL_CHAR